import { useCallback, useEffect, useRef } from "react";

// 保留時間順序的瀑布流：CSS grid + 依圖片實際高度算 row span。
// DOM 順序 = 傳入順序（不像 CSS columns 會打亂閱讀順序）。
//   photos      : 已排序好的照片陣列
//   indexBase   : Fig 編號 / 點擊 index 的起算值（散影分月時用來接續）
//   onItemClick : (globalIndex) => void
//   coverSet    : 封面組 id 陣列，命中者標「封面 #n」（可選）
const ROW = 4;
const GAP = 8;

export default function Masonry({ photos, indexBase = 0, onItemClick, coverSet = [] }) {
  const gridRef = useRef(null);

  const layout = useCallback(() => {
    const grid = gridRef.current;
    if (!grid) return;
    grid.querySelectorAll(".m-item").forEach((item) => {
      item.style.gridRowEnd = "auto";
      const h = item.getBoundingClientRect().height;
      const span = Math.max(1, Math.ceil((h + GAP) / (ROW + GAP)));
      item.style.gridRowEnd = `span ${span}`;
    });
  }, []);

  useEffect(() => {
    layout();
    window.addEventListener("resize", layout);
    return () => window.removeEventListener("resize", layout);
  }, [layout, photos]);

  return (
    <div className="m-grid" ref={gridRef}>
      {photos.map((p, i) => {
        const gi = indexBase + i;
        const coverPos = coverSet.indexOf(p.id); // -1 = 不在封面組
        return (
          <div className="m-item" key={p.id}>
            <button
              className="m-btn"
              onClick={() => onItemClick?.(gi)}
              aria-label={`Photograph ${gi + 1}`}
            >
              <img
                src={p.thumb}
                alt={p.originalName || p.id}
                loading="lazy"
                referrerPolicy="no-referrer"
                onLoad={layout}
              />
              <span className="m-fig">Fig.{String(gi + 1).padStart(2, "0")}</span>
              {coverPos >= 0 && <span className="m-cover">封面 #{coverPos + 1}</span>}
            </button>
            {p.original && (
              <a
                className="m-dl"
                href={p.original}
                target={p.source === "drive" ? "_blank" : undefined}
                rel="noopener noreferrer"
                title="下載原圖"
                onClick={(e) => e.stopPropagation()}
              >↓</a>
            )}
          </div>
        );
      })}
    </div>
  );
}
